export const FAQ_TRANSFER = {
  title: "CHUYỂN - NHẬN TIỀN",
  subItems: [
    {
      id: 'transfer-receive',
      title: "Chuyển, nhận tiền",
      contentItems: [
        {
          id: 'cau-1',
          title: "Hạn mức chuyển/nhận tiền mỗi ngày là bao nhiêu?",
          content: (
            <div>
              <p className="text-gray-700">Hạn mức chuyển tiền của tài khoản GooPay tùy thuộc vào tình trạng tài khoản đã được xác thực bằng thẻ/tài khoản ngân hàng hay chưa. Cụ thể:</p>
              <ul className="text-gray-700">1. Tài khoản GooPay có xác thực bằng thẻ/tài khoản ngân hàng
              <li className="text-gray-700">Hạn mức chuyển tiền: tối đa 30.000.000đ/ngày</li>
              <li className="text-gray-700">Hạn mức nhận tiền: tối đa 100.000.000đ/ngày</li>
              </ul>
              <ul className="text-gray-700">2. Tài khoản GooPay chưa xác thực bằng thẻ/tài khoản ngân hàng: Tài khoản này không thể sử dụng nguồn tiền GooPay trong ví.</ul>
              <p className="text-gray-700 mt-4">Để biết bạn bè nào của mình đang dùng GooPay hay không, bạn có thể kiểm tra nhanh với 2 bước dưới đây:</p>
              <p className="text-gray-700">Bước 1: Tại màn hình chính, chọn "Chuyển tiền GooPay".</p>
              <p className="text-gray-700">Bước 2: Chọn "Đến Ví GooPay" → Ở phần "DANH BẠ" sẽ hiển thị toàn bộ bạn bè của bạn đang sử dụng Ví GooPay và bạn có thể chuyển tiền ngay đến họ.</p>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Làm sao để biết bạn bè tôi có GooPay hay không để chuyển tiền?",
          content: (
            <div>
              <p className="text-gray-700">Khi rút tiền từ GooPay về tài khoản Ngân hàng liên kết, bạn sẽ được MIỄN PHÍ rút tiền cho 10 GIAO DỊCH RÚT TIỀN ĐẦU TIÊN TRONG THÁNG, tối đa đến 50 triệu đồng/tháng.</p>
              <p className="text-gray-700">Với giao dịch Rút tiền từ lần thứ 11 (hoặc hết hạn mức) sẽ tính mức phí 3.300Đ + 0,65% x Giá trị giao dịch.</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Tôi có lấy lại tiền cho các giao dịch chuyển tiền thành công được không?",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp bạn chuyển tiền đến Ví GooPay, bạn có thể trao đổi trực tiếp với Người nhận để chuyển lại tiền, bằng cách nhấn "Trò chuyện" ở màn hình Chi tiết giao dịch trên ứng dụng GooPay.</p>
              <p className="text-gray-700">Với vai trò là Trung gian thanh toán, GooPay cần đảm bảo an toàn và bảo mật thông tin cho Khách hàng, vì vậy không thể tác động hủy hoặc thay đổi nội dung giao dịch thực hiện bởi Khách hàng.</p>
            </div>
          )
        },
        {
          id: 'cau-4',
          title: "Không có nguồn tiền trong GooPay, tôi có thể chuyển tiền được không?",
          content: (
            <div>
              <p className="text-gray-700">Không có nguồn tiền trong GooPay, bạn vẫn có thể thực hiện chuyển tiền qua điện thoại trực tiếp từ các nguồn tiền khác:</p>
              <p className="text-gray-700">1. Nguồn tiền từ tài khoản ngân hàng đang liên kết</p>
              <p className="text-gray-700">2. Nguồn tiền thẻ ATM Napas (Không giới hạn số thẻ liên kết)</p>
            </div>
          )
        },
        {
          id: 'cau-5',
          title: "Nếu không có nhu cầu sử dụng tiền trong GooPay, tôi có thể rút ra không?",
          content: (
            <div>
              <p className="text-gray-700 font-semibold">Các hình thức chuyển tiền trên GooPay:</p>
              <p className="text-gray-700">1. Chuyển tiền bằng số điện thoại (từ Ví GooPay đến Ví GooPay)</p>
              <p className="text-gray-700">2. Chuyển tiền từ Ví GooPay đến số tài khoản/thẻ ngân hàng</p>
              <p className="text-gray-700">3. Gửi yêu cầu chuyển tiền</p>
              <p className="text-gray-700">4. Gửi yêu cầu chia tiền nhóm</p>
              <p className="text-gray-700">5. Quét mã chuyển tiền</p>
              <p className="text-gray-700">6. Gởi link yêu cầu Chuyển tiền</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "GooPay hiện đang có các hình thức chuyển tiền nào?",
          content: (
            <div>
              <p className="text-gray-700">Bạn vẫn có thể chuyển tiền qua điện thoại cho người chưa có tài khoản GooPay.</p>
              <p className="text-gray-700">Lúc này, người nhận tiền sẽ nhận được thông báo qua tin nhắn SMS kèm đường dẫn tải ứng dụng GooPay. Trong vòng 48 giờ, người nhận chỉ cần tải và đăng ký tài khoản GooPay là có thể nhận tiền.</p>
              <p className="text-gray-700">Trường hợp quá 48 giờ, người được nhận tiền chưa kịp đăng ký tài khoản GooPay, số tiền đã chuyển sẽ tự động được hoàn trả vào tài khoản GooPay của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-7',
          title: "Tôi có thể chuyển tiền cho người chưa có tài khoản GooPay không?",
          content: (
            <div>
              <p className="text-gray-700">Ngay sau khi bạn hoàn tất giao dịch chuyển tiền qua điện thoại, người nhận sẽ nhận được tiền trong tài khoản GooPay của mình kèm với tin nhắn thông báo trong ứng dụng. Bạn hãy nhắc người nhận mở ứng dụng GooPay để kiểm tra số dư tài khoản hoặc tin nhắn trong quả chuông ở góc phải bên trên màn hình chính.</p>
              <p className="text-gray-700">Trường hợp người nhận chưa có tài khoản GooPay, bạn hãy nhắc người nhận kiểm tra tin nhắn SMS. Trong vòng 48 giờ, nếu người nhận không đăng ký tài khoản GooPay, bạn sẽ nhận được tin nhắn SMS thông báo là số tiền đã được hoàn trả vào tài khoản của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-8',
          title: "Sau bao lâu người nhận sẽ nhận được tiền?",
          content: (
            <div>
              <p className="text-gray-700">Ngay sau khi bạn hoàn tất giao dịch chuyển tiền qua điện thoại, người nhận sẽ nhận được tiền trong tài khoản GooPay của mình kèm với tin nhắn thông báo trong ứng dụng. Bạn hãy nhắc người nhận mở ứng dụng GooPay để kiểm tra số dư tài khoản hoặc tin nhắn trong quả chuông ở góc phải bên trên màn hình chính.</p>
              <p className="text-gray-700">Trường hợp người nhận chưa có tài khoản GooPay, bạn hãy nhắc người nhận kiểm tra tin nhắn SMS. Trong vòng 48 giờ, nếu người nhận không đăng ký tài khoản GooPay, bạn sẽ nhận được tin nhắn SMS thông báo là số tiền đã được hoàn trả vào tài khoản của bạn.</p>
            </div>
          )
        },
        {
          id: 'cau-9',
          title: "Sử dụng GooPay chuyển tiền có an toàn không?",
          content: (
            <div>
              <p className="text-gray-700">Công nghệ bảo mật của GooPay đáp ứng các tiêu chuẩn quốc tế trong ngành tài chính ngân hàng. Vì vậy, bạn có thể chuyển tiền an toàn đến bạn bè, người thân xung quanh.</p>
              <p className="text-gray-700">GooPay khuyến cáo bạn không truy cập vào các đường link lạ và TUYỆT ĐỐI không cung cấp mật khẩu, OTP (mã xác thực) cho bất kỳ ai.</p>
            </div>
          )
        },
        {
          id: 'cau-10',
          title: "Số tiền tối thiểu có thể chuyển qua GooPay là bao nhiêu?",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể chuyển được số tiền nhỏ nhất, từ 100 đồng.</p>
              <p className="text-gray-700">Đặc biệt, bạn có thể chuyển từng đồng tiền lẻ ví dụ: 888 đồng, 999 đồng hoặc 123 đồng.</p>
            </div>
          )
        },
        {
          id: 'cau-11',
          title: "Tôi cần làm gì nếu chuyển nhầm đến Ví GooPay không còn sử dụng?",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể trao đổi trực tiếp với Người nhận để tạo Ví GooPay mới, bằng cách nhấn "Trò chuyện" ở màn hình Chi tiết giao dịch trên ứng dụng GooPay.</p>
              <p className="text-gray-700">Bạn có thể hướng dẫn Người nhận để tạo Ví mới, sau đó liên hệ lại GooPay để GooPay hỗ trợ người nhận điều chuyển số tiền từ Ví cũ sang Ví mới bạn nhé.</p>
              <p className="text-gray-700">Với vai trò là Trung gian thanh toán, GooPay cần đảm bảo an toàn và bảo mật thông tin cho Khách hàng, vì vậy không thể tác động hủy hoặc thay đổi nội dung giao dịch thực hiện bởi Khách hàng.</p>
            </div>
          )
        },
        {
          id: 'cau-12',
          title: "Tôi có thể chuyển tiền qua GooPay vào thời gian nào?",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể sử dụng tính năng chuyển tiền qua điện thoại trên GooPay vào bất cứ lúc nào (tất cả các ngày trong tuần, kể cả ngày cuối tuần, lễ, Tết). Thời gian chuyển tiền 24/7.</p>
            </div>
          )
        },
        {
          id: 'cau-13',
          title: "Nếu chưa xác thực tài khoản GooPay và chưa liên kết ngân hàng thì tôi có thể thực hiện giao dịch chuyển tiền không?",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp này bạn không thể thực hiện giao dịch được bằng nguồn tiền trên Ví GooPay. Tuy nhiên, bạn vẫn có thể giao dịch thanh toán trực tiếp bằng cách chọn nguồn tiền thanh toán thẻ ATM nội địa qua cổng thanh toán Napas.</p>
              <p className="text-gray-700">Các hình thức trên chỉ hỗ trợ một số dịch vụ nhất định, không áp dụng cho giao dịch chuyển tiền nên bạn hãy nhanh chóng xác thực tài khoản GooPay và liên kết tài khoản ngân hàng để sử dụng tất cả các dịch vụ trên GooPay.</p>
            </div>
          )
        },
        {
          id: 'cau-14',
          title: "Tôi có bị giới hạn số tiền được nhận từ khách hàng/bạn bè về Ví GooPay của mình mỗi ngày không?",
          content: (
            <div>
              <p className="text-gray-700">Có. Theo quy định, hạn mức nhận tiền tối đa là 50.000.000đ/ngày. Hạn mức này áp dụng cho tất cả tài khoản Ví GooPay gồm: tài khoản đã xác thực, tài khoản chưa xác thực.</p>
            </div>
          )
        },
        {
          id: 'cau-15',
          title: "Khi chuyển tiền, nếu gặp sự cố và người nhận không nhận được tôi phải làm sao?",
          content: (
            <div>
              <p className="text-gray-700">Nếu giao dịch báo lỗi và người nhận không nhận được khi chuyển tiền qua điện thoại, bạn có thể gửi hỗ trợ GooPay theo 2 cách dưới đây:</p>
              <p className="text-gray-700 mt-2">Cách 1:</p>
              <p className="text-gray-700">Tại màn hình chính chọn "Lịch sử giao dịch" → Chọn giao dịch bạn cần hỗ trợ</p>
              <p className="text-gray-700">Tại màn hình Chi tiết giao dịch chọn "Liên hệ hỗ trợ" → Làm theo hướng dẫn để gửi yêu cầu trợ giúp về cho GooPay</p>
              <p className="text-gray-700 mt-2">Cách 2: Gửi email đến địa chỉ cskh@goopay.vn hoặc gọi đến CSKH của GooPay theo số hotline: 19006038 (1.000đ/phút)</p>
            </div>
          )
        },
        {
          id: 'cau-16',
          title: "Vì sao tài khoản đã bị trừ tiền nhưng tài khoản ngân hàng người nhận chưa nhận được?",
          content: (
            <div>
              <p className="text-gray-700 font-semibold">Chuyển tiền đến Ngân hàng là gì?</p>
              <p className="text-gray-700">Chuyển tiền đến Ngân hàng là giao dịch bạn sử dụng ứng dụng GooPay để thực hiện chuyển tiền đến thẻ/tài khoản Ngân hàng của bạn, người thân hoặc bạn bè một cách dễ dàng bằng 1 trong các hình thức:</p>
              <p className="text-gray-700">1️⃣ Nhập số tài khoản/số thẻ.</p>
              <p className="text-gray-700">2️⃣ Chọn tài khoản/thẻ đã được lưu sẵn.</p>
              <p className="text-gray-700">3️⃣ Quét mã QR ngân hàng.</p>
              
              <p className="text-gray-700 font-semibold mt-4">Lợi ích chuyển tiền đến Ngân hàng là gì?</p>
              <p className="text-gray-700">✔️ Hệ thống chuyển tiền nhanh Napas 24/7, cho phép chuyển tiền trong suốt 24h và 7 ngày trong tuần.</p>
              <p className="text-gray-700">✔️ Tiền chuyển đến ngay, không cần chờ đợi.</p>
              <p className="text-gray-700">✔️ Lưu thông tin giao dịch, thông tin tài khoản/số thẻ cho lần giao dịch sau.</p>
              <p className="text-gray-700">✔️ Mọi giao dịch chuyển tiền trên GooPay đều đảm bảo an toàn, bảo mật chuẩn quốc tế.</p>
              
              <p className="text-gray-700 font-semibold mt-4">Chuyển đến Ngân hàng nhưng tài khoản thụ hưởng chưa nhận được?</p>
              
              <p className="text-gray-700 font-semibold mt-2">1️. Nếu trạng thái giao dịch "Đang chờ xử lý"</p>
              <p className="text-gray-700">Nguyên nhân xảy ra do dữ liệu giữa GooPay và Ngân hàng chưa đồng bộ kịp thời. Vì thế, GooPay sẽ cần tiến hành thực hiện đối soát giao dịch với hệ thống Ngân hàng.</p>
              <p className="text-gray-700">Thời gian dự kiến hệ thống cập nhật trạng thái trong vòng 1-2 ngày làm việc (không tính ngày thứ Bảy, Chủ Nhật và ngày Lễ). Thời gian có thể kéo dài hơn dự kiến do quy trình làm việc của từng Ngân hàng, ngay khi có kết quả xử lý GooPay sẽ phản hồi bạn trong thời gian sớm nhất.</p>
              
              <p className="text-gray-700 font-semibold mt-2">Sau khi hệ thống cập nhật trạng thái:</p>
              <p className="text-gray-700">✔️ Nếu trạng thái "Thành công": Tài khoản người nhận sẽ nhận được tiền.</p>
              <p className="text-gray-700">✔️ Nếu trạng thái "Thất bại": Hệ thống sẽ hoàn tiền về tài khoản Ví GooPay hoặc hoàn tiền về ngân hàng nếu bạn sử dụng nguồn tiền ngân hàng liên kết để chuyển tiền.</p>
              
              <p className="text-gray-700 font-semibold mt-2">Bạn có thể theo dõi tiến độ giao dịch theo 2 cách sau:</p>
              <p className="text-gray-700">✔️ Tại màn hình lịch sử giao dịch. Mục "Lịch sử giao dịch"</p>
              <p className="text-gray-700">✔️ GooPay sẽ thông báo kết quả cuối cùng thành công hay thất bại (hình quả chuông kế bên thanh tìm kiếm trên ứng dụng) chuyển tiền ở mục "Quan trọng". Bạn hãy cho phép GooPay gửi thông báo đến bạn để được cập nhật kết quả sớm nhất. Nếu quá thời gian trên vẫn chưa nhận được kết quả bạn vui lòng chọn "Trợ giúp" và gửi yêu cầu để được hỗ trợ.</p>
              
              <p className="text-gray-700 font-semibold mt-4">Nếu trạng thái giao dịch"Thành công"</p>
              <p className="text-gray-700">Thông thường, chuyển tiền trạng thái "Thành công" ngân hàng sẽ cập nhật tiền ngay vào tài khoản thụ hưởng. Tuy nhiên, trong một vài trường hợp tài khoản thụ hưởng có thể được cập nhật tiền chậm hơn hoặc người nhận không nhận được thông báo nhận tiền như:</p>
              
              <p className="text-gray-700 font-semibold mt-2">✔️ Nếu thông tin chuyển tiền chính xác có thể phát sinh:</p>
              <p className="text-gray-700">1️⃣ Lỗi đường truyền hoặc bảo trì hệ thống giữa các Ngân hàng liên kết.</p>
              <p className="text-gray-700">Các ngân hàng thường xuyên tiến hành bảo trì hệ thống nhằm bảo vệ thông tin khách hàng khỏi sự tấn công của hacker. Quá trình này có thể ảnh hưởng đến tiến độ gửi tin nhắn thông báo hoặc cập nhật sao kê giao dịch chuyển tiền.</p>
              <p className="text-gray-700">2️⃣ Chuyển tiền vào cuối tuần, ngày lễ tết hoặc giờ cao điểm.</p>
              <p className="text-gray-700">Thời điểm giao dịch vào ngày lễ hoặc cuối tuần có thể ảnh hưởng đến tiến trình giao dịch. Đó là bởi hệ thống ngân hàng điện tử của một số ngân hàng thường hoạt động chậm vào những dịp này. Vì vậy, các giao dịch vẫn sẽ được thực hiện nhưng với tốc độ chậm hơn.</p>
              <p className="text-gray-700">3️⃣ Số điện thoại nhận thông báo nhận tiền đã bị thay đổi.</p>
              <p className="text-gray-700">Khi người nhận thay đổi số điện thoại, sẽ không nhận được phản hồi từ ngân hàng khi giao dịch chuyển tiền thành công. Vì vậy, khi đăng ký dịch vụ SMS Banking, người nhận nên sử dụng số điện thoại liên lạc chính để nhận được tin nhắn biến động số dư.</p>
              <p className="text-gray-700">4️⃣ Tùy thuộc vào quy định nhận tiền của ngân hàng thụ hưởng.</p>
              <p className="text-gray-700">Mỗi ngân hàng thụ hưởng sẽ có quy trình xử lý khác nhau nên thời gian cập nhật tiền cũng sẽ chênh lệch.</p>
              <p className="text-gray-700">💡 Bạn yên tâm, số tiền sẽ được cập nhật khi ổn định và có thể chậm nhất trong vòng 1- 3 ngày làm việc (không tính ngày thứ Bảy, Chủ Nhật và ngày Lễ) tùy thuộc vào hệ thống ngân hàng thụ hưởng của người nhận.</p>
              <p className="text-gray-700">Bạn có thể chia sẻ biên lai chuyển tiền và thông báo người nhận kiểm tra lại sao kê tài khoản thụ hưởng trong thời gian này.</p>
              <p className="text-gray-700">Mỗi ngân hàng thụ hưởng sẽ có quy trình xử lý khác nhau nên thời gian cập nhật tiền cũng sẽ chênh lệch.</p>
              <p className="text-gray-700">💡 Bạn yên tâm, số tiền sẽ được cập nhật khi ổn định và có thể chậm nhất trong vòng 1- 3 ngày làm việc (không tính ngày thứ Bảy, Chủ Nhật và ngày Lễ) tùy thuộc vào hệ thống ngân hàng thụ hưởng của người nhận.</p>
              <p className="text-gray-700">Bạn có thể chia sẻ biên lai chuyển tiền và thông báo người nhận kiểm tra lại sao kê tài khoản thụ hưởng trong thời gian này.</p>
              <p className="text-gray-700">Nếu quá thời gian trên vẫn chưa nhận được vui lòng nhấn vào chi tiết giao dịch và gửi yêu trợ giúp.</p>
              
              <p className="text-gray-700 font-semibold mt-2">✔️ Nếu thông tin chuyển tiền sai:</p>
              <p className="text-gray-700">Người gửi nhập sai các thông tin như số thẻ/tài khoản hoặc chọn nhầm Ngân hàng, tiền vẫn bị trừ nhưng người nhận sẽ không nhận được bất kỳ phản hồi nào. Trong trường hợp này, bạn vui lòng kiểm tra lại thông tin chi tiết chuyển tiền. Khi phát hiện chuyển tiền sai người nhận, bạn cần nhanh chóng gửi yêu cầu trợ giúp để hỗ trợ kịp thời.</p>
              
              <p className="text-gray-700 font-semibold mt-2">Lưu ý:</p>
              <p className="text-gray-700">Kết quả số tiền chuyển nhầm có khả năng rút lại được hay không tùy thuộc vào sự đồng ý của người nhận nhầm.</p>
              <p className="text-gray-700">Thời gian xử lý phụ thuộc vào quy trình xử lý của ngân hàng thụ hưởng có thể lên đến 60 ngày làm việc (không tính thứ Bảy, Chủ Nhật và ngày Lễ).</p>
              
              <p className="text-gray-700 font-semibold mt-4">Nếu trạng thái giao dịch "Thất bại"</p>
              <p className="text-gray-700">Đối với giao dịch trạng thái " Thất bại" tài khoản của bạn chắc chắn sẽ không bị trừ tiền. Số tiền giao dịch sẽ được cập nhật bằng một trong các hình thức khi bạn sử nguồn tiền để chuyển tiền như:</p>
              <p className="text-gray-700">✔️ Nguồn tiền Ví: Thoát ứng dụng, đăng nhập lại để kiểm tra số dư Ví.</p>
              <p className="text-gray-700">✔️ Nguồn tiền Ngân hàng: Kiểm tra lại số dư tài khoản ngân hàng hoặc số dư ví GooPay.</p>
              <p className="text-gray-700">Nếu có phát sinh giao dịch hoàn tiền về Ngân hàng nhưng tài khoản vẫn chưa nhận được bạn vui lòng chờ thêm trong vòng 1 - 2 ngày làm việc (không tính ngày thứ Bảy, Chủ Nhật và ngày Lễ) để Ngân hàng thực hiện đối soát và cập nhật. Số tiền hoàn về có thể được hiện trong báo cáo sao kê tài khoản nếu bạn không sử dụng tính năng thông báo số dư - SMS banking.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'transfer-request',
      title: "Yêu cầu chuyển tiền",
      contentItems: [
        {
          id: 'cau-17',
          title: "Mã QR cá nhân khác với Mã thanh toán như thế nào?",
          content: (
            <div>
              <p className="text-gray-700">Mã QR cá nhân (Mã QR Của Tôi) là mã đại diện cho tài khoản GooPay của bạn. Bạn có thể gửi mã QR này cho bất kỳ người nào. Người nhận được sử dùng tính năng quét mã QR sẽ hiển thị số tài khoản GooPay của bạn, và có thể chuyển tiền cho bạn một cách nhanh chóng. Bạn có thể vào mục "Ví Của Tôi", sau đó nhấp vào tên của bạn để mở mã QR Của Tôi.</p>
              <p className="text-gray-700">Mã Thanh Toán là mã QR sử dụng cho dịch vụ Thanh Toán Tại Quầy tại các siêu thị, nhà hàng, cafe... có chấp nhận thanh toán GooPay. Bạn có thể nhấp vào "Mã thanh toán" tại màn hình chính để mở mã QR này rồi cho thu ngân để được thanh toán.</p>
            </div>
          )
        },
        {
          id: 'cau-18',
          title: "Cách yêu cầu người khác chuyển tiền cho mình bằng GooPay",
          content: (
            <div>
              <p className="text-gray-700">Tính năng "Yêu cầu chuyển tiền" của GooPay cho phép bạn gửi yêu cầu cho người mà bạn muốn "đòi nợ" hoặc mượn tiền, giúp người đó có thể dễ dàng chuyển tiền cho bạn. Cách thực hiện:</p>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn tính năng "Yêu cầu chuyển tiền"</p>
              <p className="text-gray-700">Bước 2: Chọn tên người được yêu cầu trong danh bạ hoặc nhập số điện thoại của người đó</p>
              <p className="text-gray-700">Bước 3: Nhập số tiền được yêu cầu (bắt buộc) và lời nhắn đi kèm (không bắt buộc)</p>
              <p className="text-gray-700">Bước 4: Kiểm tra thông tin và chọn "Xác nhận".</p>
              <p className="text-gray-700">Sau khi bạn hoàn tất, người được yêu cầu chuyển tiền sẽ nhận được thông báo trên ứng dụng GooPay của người đó. Người đó chỉ cần bấm xác nhận chuyển tiền là lệnh chuyển tiền lập tức được thực hiện.</p>
            </div>
          )
        },
        {
          id: 'cau-19',
          title: "Cách gửi mã QR cá nhân để người khác chuyển tiền cho mình",
          content: (
            <div>
              <p className="text-gray-700">Việc gửi mã QR cá nhân giúp người khác có thể dễ dàng chuyển tiền cho bạn chỉ với 1 thao tác quét mã QR trên GooPay.</p>
              <p className="text-gray-700">Để gửi mã QR cá nhân, bạn thực hiện các bước sau:</p>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng chọn "Ví của tôi"</p>
              <p className="text-gray-700">Bước 2: Nhấp vào tên của bạn để vào mục "Thông tin cá nhân" rồi chọn "Mã QR của tôi"</p>
              <p className="text-gray-700">Bước 3: Chạm vào mã QR để hiển thị các tùy chọn:</p>
              <p className="text-gray-700">- Chia sẻ mã QR: gửi mã QR cho người khác</p>
              <p className="text-gray-700">- Lưu mã QR: lưu hình ảnh của mã QR trong điện thoại rồi gửi hình cho người khác</p>
              <p className="text-gray-700">Sau khi nhận được mã QR của bạn, người gửi chỉ cần bật tính năng quét mã từ màn hình chính của ứng dụng GooPay, quét mã và xác nhận lệnh chuyển tiền.</p>
            </div>
          )
        }
      ]
    }
  ]
}; 